<template>
	<div id="slips" class="betslip">
		<div v-if="bets.length > 0" class="betslip-content">
			<div class="rounded-card">
				<bet
					v-for="(bet, keyValue) in bets"
					:bet="bet"
					:key="bet.parent_virtual_id"
					:currentTime="currentTime"
					:keyValue="keyValue + 1"
				/>
			</div>
		</div>
		<div v-else class="betslip-content--empty">
			{{ this.$t("betslip.no-virtual-bets-in-betslip") }}
			<!-- You have no virtual bets in your betslip.
			<br />Kindly add some bets  -->
			<br />
			<br />
			<router-link
				:to="this.env.virtualRoute"
				class="button button__secondary"
				>{{ this.$t("betslip.go-to-virtual-sports") }}</router-link
			>
		</div>
		<div v-if="bets.length > 0" class="betslip__details">
			<div class="betslip__details__container">
				<div class="betslip__details__left">
					<div
						class="betslip__details__row"
						v-show="$store.getters.balance > 0 && loggedIn"
					>
						<span class="betslip__details__row__label">{{
							$t("betslip.wallet-balance")
						}}</span>
						<span class="betslip__details__row__value bold">{{
							$store.getters.balance | currency
						}}</span>
					</div>

					<div class="betslip__details__row">
						<span class="betslip__details__row__label">
							<span style="margin-right: 5px">{{
								$t("betslip.total-odds")
							}}</span>
							<b-popup
								:rows="[
									{
										label: this.$t('general.min'),
										value: env.minTotalOdd,
										show: env.minTotalOdd,
									},
								]"
								:placement="'top-left'"
								:iconType="'solid'"
							/>
						</span>
						<div class="betslip__details__row__value bold">
							{{ totalOdds }}
						</div>
					</div>

					<!-- Final Payout -->
					<div class="betslip__details__row">
						<span class="betslip__details__row__label">
							<span style="margin-right: 5px">{{
								$t("betslip.final-payout")
							}}</span>
							<b-popup
								:rows="[
									{
										label: this.$t('betslip.excise-tax'),
										value: $options.filters.currency(exciseTax || 0),
										show: env.virtualsExciseTax > 0,
									},
									{
										label: this.$t('betslip.stake'),
										value: $options.filters.currency(amount - exciseTax || 0),
										show: true,
									},
									{
										label: this.$t('betslip.win'),
										value: $options.filters.currency(possibleWinnings || 0),
										show: possibleWinnings,
									},
									{
										label: this.$t('betslip.withholding-tax'),
										value: $options.filters.currency(tax || 0),
										show: env.virtualsWhtTax > 0,
									},
								]"
								:placement="'top-left'"
								:iconType="'solid'"
							/>
						</span>
						<span class="betslip__details__row__value">
							{{ (possiblePayout || 0) | currency }}</span
						>
					</div>

					<!-- Amount -->
					<div class="betslip__details__row--amount">
						<div class="betslip__details__row">
							<div class="betslip__details__row__input__currency-wrap">
								<span class="betslip__details__row__input__currency-code"
									>{{ $t("betslip.amount") }} ({{ env.currency }})</span
								>
								<b-input
									class="betslip__details__row__value input"
									type="number"
									name="amount"
									v-model="amount"
									:disabled="placingBet"
									min="1"
									step="1"
									:placeholder="$t('betslip.enter-stake')"
									@mounted="
										$nextTick(() => {
											adjustBetslipHeight();
										})
									"
								>
								</b-input>
							</div>
						</div>
						<div
							class="betslip__details__row minmax"
							v-if="
								amount < env.minimumVirtualsBetAmount ||
								amount > env.maximumVirtualsBetAmount
							"
						>
							<span
								>{{ $t("betslip.enter-amount-between") }}
								{{ env.minimumVirtualsBetAmount | currency }} -
								{{ env.maximumVirtualsBetAmount | currency }}</span
							>
						</div>
					</div>

					<div class="betslip__details__buttons">
						<button
							id="placeBetButton"
							:amount="amount"
							:possibleWin="possibleWinnings"
							:totalOdds="totalOdds"
							:bonus="bonus"
							:points="points"
							:numberOfBets="bets.length"
							type="virtual"
							v-if="!areThereAnyInvalidMatches"
							class="button betslip__details__button__place button button__primary full bold"
							@click="placeBet"
							:disabled="
								placingBet ||
								amount < env.minimumVirtualsBetAmount ||
								isNaN(amount)
							"
							@mounted="
								$nextTick(() => {
									adjustBetslipHeight();
								})
							"
						>
							<loader v-if="placingBet" />
							<span v-else>{{
								totalOdds < env.minTotalOdd
									? this.$t("betslip.min-total-odds-of-minTotalOdd-required", {
											minTotalOdd: env.minTotalOdd,
										})
									: this.$t("betslip.button-place-bet")
							}}</span>
						</button>
						<button
							v-if="areThereAnyInvalidMatches"
							class="button account__payments__submit betslip__details__button__place button button__primary full bold"
							@click="$store.commit('removeInvalidBetsFromVirtualBetslip')"
							@mounted="
								$nextTick(() => {
									adjustBetslipHeight();
								})
							"
						>
							{{ this.$t("betslip.remove-expired") }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { isNull } from "lodash";
import Bet from "./VirtualBetslipBet.vue";
export default {
	name: "virtual-betslip",
	components: { Bet },
	data() {
		return {
			currentTime: +new Date(),
			maxPossibleWin: 1500000,
			placingBet: false,
			timerIntervalID: null,
			infoOpen: false,
		};
	},
	computed: {
		possiblePayout() {
			return Math.trunc((this.possibleWinnings - this.tax) * 100) / 100;
		},
		bets() {
			return this.$store.getters.virtualBetslip;
		},
		amount: {
			// getter
			get: function () {
				let vm = this;
				if (isNull(vm.$store.getters.stake)) {
					vm.$store.commit(
						"updateStake",
						parseFloat(vm.env.defaultStakeAmount)
					);
					return vm.env.defaultStakeAmount;
				} else {
					return vm.$store.getters.stake;
				}
			},
			// setter
			set: function (stake) {
				this.$store.commit("updateStake", parseFloat(stake));
			},
		},
		betAmount() {
			return this.amount;
		},
		totalOdds() {
			let oddValues = this.bets
				.filter((bet) => Number(bet.odd.odd_value) > 0)
				.map((bet) => Number(bet.odd.odd_value));

			return Math.trunc(oddValues.reduce((a, b) => a * b, 1) * 100) / 100;
			// return oddValues;
		},
		possibleWinnings() {
			if (isNaN(this.betAmount)) return 0;
			let possibleWin =
				Math.trunc(this.totalOdds * (this.betAmount - this.exciseTax) * 100) /
				100;
			return possibleWin > this.env.maximumVirtualsWin
				? this.env.maximumVirtualsWin
				: possibleWin;
		},
		exciseTax() {
			return (
				Math.round(
					(this.betAmount - this.betAmount / (1 + this.env.virtualsExciseTax)) *
						100
				) / 100
			);
		},
		tax() {
			let maxTax = this.possibleWinnings * this.env.virtualsWhtTax;
			let tax =
				Math.round(
					(this.possibleWinnings - (this.betAmount - this.exciseTax)) *
						this.env.virtualsWhtTax *
						100
				) / 100;
			if (tax < 0) return 0;
			return 0 || tax > maxTax ? maxTax : tax;
		},
		bonus() {
			// Give bonus to only those bets with odd values >= 1.6
			let validOdds = this.bets
				.filter((bet) => Number(bet.odd.odd_value) >= 1.6)
				.map((bet) => bet.odd.odd_value);

			let numberOfValidOdds = validOdds.length;
			let minimumCountToAwardBonus = 5;

			if (numberOfValidOdds < minimumCountToAwardBonus) return 0;
			if (numberOfValidOdds > 14) numberOfValidOdds = 14;

			let percentageBonusForCount = {
				5: 0.05,
				6: 0.06,
				7: 0.07,
				8: 0.08,
				9: 0.1,
				10: 0.1,
				11: 0.12,
				12: 0.2,
				13: 0.2,
				14: 0.2,
			};

			let bonus =
				percentageBonusForCount[numberOfValidOdds] * this.possibleWinnings;
			return bonus > this.maxBonus ? this.maxBonus : bonus;
		},
		points() {
			//  from 100 to 500 stake max points per bet is 50
			//  from 501 to 5000 stake max points per bet are 100
			//  from 5001 and above stake max points per bet are 200
			//  max points per day to be 500
			let points;
			if (this.totalOdds >= 9.99) {
				switch (true) {
					case this.amount < 49:
						points = 0;
						break;

					case this.amount >= 49 && this.amount < 100:
						points = (Number(this.amount) * Number(this.totalOdds)) / 100;
						points = points > 25 ? 25 : points;
						break;

					case this.amount >= 100 && this.amount < 501:
						points = (Number(this.amount) * Number(this.totalOdds)) / 100;
						points = points > 50 ? 50 : points;
						break;

					case this.amount > 500 && this.amount < 5001:
						points = (Number(this.amount) * Number(this.totalOdds)) / 100;
						points = points > 100 ? 100 : points;
						break;

					case this.amount > 5000:
						points = (Number(this.amount) * Number(this.totalOdds)) / 100;
						points = points > 200 ? 200 : points;
						break;

					default:
						points = 0;
						break;
				}
			} else {
				points = 0;
			}
			return points;
		},
		loggedIn() {
			return JSON.parse(window.localStorage.getItem("authenticated"));
		},
		areThereAnyInvalidMatches() {
			let vm = this;
			return false;
			return (
				this.bets.filter((bet) => {
					return +new Date(bet.start_time.replace(/-/g, "/")) < vm.currentTime;
				}).length > 0
			);
		},
		numberOfBets() {
			return this.bets.length;
		},
	},
	watch: {
		numberOfBets(n, o) {
			let vm = this;
			if (n == 1 && o == 0) {
				vm.$nextTick(() => {
					vm.adjustBetslipHeight();
				});
			}
			vm.$nextTick(() => {
				if (n === 0) return;
				document
					.querySelector(".betslip-content")
					.scroll({ behavior: "smooth", top: 10000 });
			});
		},
	},
	created() {
		this.updateCurrentTime();
	},
	beforeRouteLeave() {
		clearInterval(this.timerIntervalID);
	},
	mounted() {
		let vm = this;
		if (vm.$store.getters.layout == "Desktop" && vm.bets.length > 0) {
			vm.$nextTick(() => {
				vm.adjustBetslipHeight();
			});
		}

		if (vm.$store.getters.layout == "Desktop") {
			if (vm.bets.length === 0) return;
			document
				.querySelector(".betslip-content")
				.scroll({ behavior: "smooth", top: 10000 });
		} else {
			vm.$nextTick(() => {
				if (vm.bets.length === 0) return;
				let el = document.getElementById("slips");

				el.scrollIntoView(false);
				window.scrollBy(0, 10000);
			});
		}
	},
	methods: {
		adjustBetslipHeight() {
			if (this.$store.getters.layout !== "Desktop") return;
			var desktopOffset = parseInt(
				getComputedStyle(document.body)
					.getPropertyValue("--desktop-header-offset")
					.trim()
					.replace("px", "")
			);
			var betslipDetailsHeight = document
				.querySelector(".betslip__details")
				.getBoundingClientRect().height;

			var navHeight =
				document.querySelector(".main-betslip__nav").getBoundingClientRect()
					.height +
				document.querySelector(".main-betslip__header").getBoundingClientRect()
					.height;
			var padding = 4;
			var bottomOffset = 0;
			var betslipContentHeight = `${
				window.innerHeight -
				(desktopOffset +
					betslipDetailsHeight +
					padding +
					bottomOffset +
					navHeight)
			}px`;
			document.querySelector(".betslip-content").style.height =
				betslipContentHeight;
			document.querySelector(".betslip-content").classList.add("adjusted");
		},
		clearBetslip() {
			let betslip = this.bets.map((bet) => {
				return {
					sub_type_id: bet.odd.sub_type_id,
					special_bet_value: bet.odd.special_bet_value,
					bet_pick: bet.odd.odd_key,
					odd_value: bet.odd.odd_value,
					outcome_id: bet.odd.outcome_id,
					parent_virtual_id: bet.parent_virtual_id,
					parent_match_id: bet.parent_virtual_id,
					match_id: bet.parent_virtual_id,
					bet_type: 0,
				};
			});
			if (window.confirm(this.$t("betslip.clear-betslip"))) {
				this.analyticsTrack("betSlip", "clear", {
					bet_slip_count: betslip.length || null,
				});
				this.$store.commit("clearVirtualBetslip");
			}
		},
		updateCurrentTime() {
			let vm = this;
			vm.timerIntervalID = setInterval(() => {
				vm.currentTime = +new Date();
			}, 1000);
		},
		refreshBalance() {
			if (this.env.availableFeatures.balanceWidget) {
				this.$root.$emit("update-user-balance");
			} else {
				this.$axios
					.post(`${BASE_URL}balance`, {
						token: window.localStorage.getItem("token")
							? JSON.parse(window.localStorage.getItem("token"))
							: "",
					})
					.then((response) => {
						this.$store.commit("setBalance", response.data.data.balance);
					})
					.catch((error) => {
						console.log(error);
					});
			}
		},
		placeBet() {
			let vm = this;
			if (vm.bets.length == 0) return;
			vm.placingBet = true;
			// Check whether the user is authenticated
			if (!JSON.parse(window.localStorage.getItem("authenticated"))) {
				vm.$notifications.add({
					type: "warning",
					title: this.$t("session.authentication-required"),
					message: this.$t("session.please-login-first"),
					duration: 3000,
				});
				vm.$router.replace("/login?next=/betslip?type=virtual");
				return;
			}

			let betslip = vm.bets.map((bet) => {
				return {
					sub_type_id: bet.odd.sub_type_id,
					special_bet_value: bet.odd.special_bet_value,
					bet_pick: bet.odd.odd_key,
					odd_value: bet.odd.odd_value,
					outcome_id: bet.odd.outcome_id,
					parent_virtual_id: bet.parent_virtual_id,
					parent_match_id: bet.parent_virtual_id,
					match_id: bet.parent_virtual_id,
					bet_type: 0,
				};
			});

			let payload = {
				bet_string: "MOBILE_WEB",
				app_name: "MOBILE_WEB",
				src: "MOBILE_WEB",
				possible_win: vm.possibleWinnings,
				profile_id: window.localStorage.getItem("user")
					? JSON.parse(window.localStorage.getItem("user")).id
					: "",
				stake: vm.amount,
				total_odd: vm.totalOdds,
				token: window.localStorage.getItem("token")
					? JSON.parse(window.localStorage.getItem("token"))
					: "",
				betslip: betslip,
				deviceID: "",
				endCustomerIP: "",
				channelID: "mobile",
				user_agent: localStorage.user_agent ? localStorage.user_agent : null,
			};

			if (
				vm.$store.getters["affiliates/affiliateTag"] &&
				vm.env.availableFeatures.affiliates
			) {
				payload.affiliate_id = vm.$store.getters["affiliates/affiliateID"];
				payload.affiliate_tag = vm.$store.getters["affiliates/affiliateTag"];
			}

			this.analyticsTrack("virtualsBet", "attempt", {
				betslip: payload.betslip,
				num_Of_Bets: betslip.length,
				stake: vm.$options.filters.currency(payload.stake),
				user_id: payload.profile_id,
				bet_type: "virtuals",
			});

			let url =
				vm.env.virtualsPlacebetUrl !== null
					? `${VIRTUALS_PLACEBET_URL}virtual/placebet`
					: `${LIVE_URL}virtual/placebet`;

			vm.$axios
				.post(`${url}`, payload)
				.then((response) => {
					vm.$notifications.add({
						type: "success",
						title: this.$t("betslip.bet-placement-successful"),
						message: response.data.message,
						duration: 10000,
					});

					vm.placingBet = false;
					vm.refreshBalance();
					this.analyticsTrack("virtualsBet", "success", {
						betslip: payload.betslip,
						stake: vm.$options.filters.currency(vm.amount),
						total_odds: vm.totalOdds,
						user_id: payload.profile_id,
						message: response.data.message,
						bet_type: "virtuals",
						value: Number(vm.amount) || 0,
						currency: window.CURRENCY,
					});
					vm.$store.commit("SET_MYBETS_LAST_FETCH_TIME", null);
					if (!vm.keep) {
						vm.$store.commit("clearVirtualBetslip");
						vm.$router.push("/virtual");
					}
				})
				.catch((error) => {
					vm.placingBet = false;
					this.analyticsTrack("virtualsBet", "failed", {
						betslip: payload.betslip,
						num_Of_Bets: betslip.length,
						stake: vm.$options.filters.currency(vm.amount),
						bet_type: "virtuals",
						user_id: payload.profile_id,
						message: error.response
							? error.response.data.message
							: error.message,
					});
					if (error.response && error.response.status == 401) {
						window.localStorage.setItem("authenticated", false);
						window.localStorage.removeItem("user");
						window.localStorage.removeItem("token");

						vm.$notifications.add({
							message: this.$t("session.session-expired"),
							title: this.$t("session.expired"),
							type: "error",
							duration: 5000,
						});
						this.$router.replace("/login?next=/betslip?type=virtual");
						return;
					}
					vm.$notifications.add({
						type: "error",
						title: this.$t("betslip.bet-placement-failed"),
						message: error.response
							? error.response.data.message
							: this.$t("session.an-error-occured-please-try-again"),
						duration: 10000,
					});
				});
		},
	},
};
</script>
